// src/redux/rootReducer.js
import { combineReducers } from "redux";
import cartReducer from "./cartReducer";
import languageReducer from "./languageReducer";
import userReducer from "./userReducer";
import dataReducer from "./dataReducer";
import creatorReducer from "./creatorReducer";
import swayamCreatorReducer from "./swayamCreatorReducer";
import bhogCartReducer from "./bhogCartSlice";

const rootReducer = combineReducers({
  cart: cartReducer,
  language: languageReducer,
  user: userReducer,
  creator: creatorReducer,
  swayamCreator: swayamCreatorReducer,
  data: dataReducer,
  bhogCart: bhogCartReducer,
});

export default rootReducer;
